import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import ThumbList from '../ThumbList';
import CurriculumTable from '../CurriculumTable';
import { formatTableData, isCustomCategory } from '../../utils/search-utils';

const messages = defineMessages({
  seeAll: { id: 'searchSummary.seeAll', defaultMessage: 'See {total} {type}' },
});

const SearchSummary = ({ hasSubscription, intl, onClick, query, small, summaryArr, history }) => {
  if (!summaryArr) {
    return null;
  }
  const { formatMessage } = intl;
  let styles = {
    curriculum: 'dn-ns',
    header: 'f3-ns',
    link: 'f5-ns',
    thumbs: 'db-ns',
    titleContainer: 'mb3 bb b--moon-gray ',
  };
  if (small) {
    styles = { curriculum: '', header: '', link: '', thumbs: '', titleContainer: '' };
  }
  return (
    <div className="search-summary">
      {summaryArr.map((summaryItem, index) => {
        const { items, title, total, type, url } = summaryItem || {};
        const customCategory = isCustomCategory(title);
        const display = {
          chords: false,
          description: customCategory,
          level: false,
        };
        if (!summaryItem || !items.length) {
          return null;
        }
        return (
          <div
            className="mb4"
            data-id={`search-summary-item-${index}`}
            key={`summary-item-${type}-${url}`}
          >
            <div
              className={`pb1 mb1 bb b--light-gray flex items-center justify-between ${styles.titleContainer}`}
            >
              <h3 className={`f4 futura-heavy mv0 ttc dib ${styles.header}`}>{title}</h3>
              {url ? (
                <button
                  type="button"
                  className={`bg-transparent bn blue no-underline f6 source-sans pointer ${styles.link}`}
                  onClick={() => {
                    history.push(url);
                    onClick();
                  }}
                >
                  {formatMessage(messages.seeAll, { total, type: title })}
                </button>
              ) : null}
            </div>
            <div className={`dn ${styles.thumbs}`} data-id={`search-summary-thumblist-${index}`}>
              <ThumbList
                circle={title === 'Artists'}
                isScrollerEnabled={false}
                itemClasses="mr2 mr3-l"
                itemArr={items || []}
                onClick={onClick}
                showDescription={customCategory}
                variantType="smallThumb"
              />
            </div>
            <div className={`db ${styles.curriculum}`} data-id={`search-summary-table-${index}`}>
              <CurriculumTable
                content={formatTableData(items, query, hasSubscription)}
                display={display}
                onClick={onClick}
                style={`${title === 'Artists' ? 'circle' : 'square'}`}
                small
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

SearchSummary.propTypes = {
  hasSubscription: PropTypes.bool,
  intl: intlShape.isRequired,
  onClick: PropTypes.func,
  query: PropTypes.string,
  small: PropTypes.bool,
  summaryArr: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.string,
          title: PropTypes.string,
          subTitle: PropTypes.string,
          overlayTitle: PropTypes.string,
          overlayColor: PropTypes.string,
          url: PropTypes.string,
          level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          type: PropTypes.string,
        }),
      ),
    }),
  ),
};

SearchSummary.defaultProps = {
  hasSubscription: false,
  onClick: () => {},
  query: '',
  small: false,
  summaryArr: null,
};

export default injectIntl(withRouter(SearchSummary));
